export default function FragmentedSystemsPreview({ className = "" }) {
  return (
    <svg
      viewBox="0 0 214 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Disconnected modules converging to a blocked central point"
      className={`h-full w-full ${className}`}
    >
      <g>
        <rect width="44" height="44" rx="8" fill="#FCFCFC" />
        <path
          d="M19 14V12M25 30V32M14 19H12M30 25H32M14.9142 14.9142L13.5 13.5M29.0858 29.0858L30.5 30.5M22 27.6569L19.8787 29.7782C18.3166 31.3403 15.7839 31.3403 14.2218 29.7782C12.6597 28.2161 12.6597 25.6834 14.2218 24.1213L16.3431 22M27.6569 22L29.7782 19.8787C31.3403 18.3166 31.3403 15.7839 29.7782 14.2218C28.2161 12.6597 25.6834 12.6597 24.1213 14.2218L22 16.3431"
          stroke="#292929"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <g>
        <rect width="44" height="44" rx="8" fill="#FDF3F3" />
        <path
          d="M30.3995 31.5999L30.3998 28.0002C30.4 26.0119 28.7881 24.3999 26.7998 24.3999H17.2005C15.2124 24.3999 13.6007 26.0114 13.6005 27.9995L13.6001 31.5999M25.6001 15.9999C25.6001 17.9881 23.9883 19.5999 22.0001 19.5999C20.0119 19.5999 18.4001 17.9881 18.4001 15.9999C18.4001 14.0117 20.0119 12.3999 22.0001 12.3999C23.9883 12.3999 25.6001 14.0117 25.6001 15.9999Z"
          stroke="#AD2828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <g>
        <rect x="56.4326" width="44" height="44" rx="8" fill="#FDF3F3" />
        <path
          d="M81.4327 12.3999V15.9999C81.4327 16.6626 81.97 17.1999 82.6327 17.1999H86.2327M74.8327 17.1999H77.2327M74.8327 20.7999H82.0327M74.8327 24.3999H82.0327M84.4327 14.1999C83.8986 13.722 83.3444 13.1553 82.9945 12.7872C82.7617 12.5422 82.4401 12.3999 82.1021 12.3999H73.0324C71.7069 12.3999 70.6324 13.4744 70.6324 14.7999L70.6323 29.1998C70.6323 30.5253 71.7068 31.5998 73.0323 31.5998L83.8324 31.5999C85.1578 31.5999 86.2323 30.5254 86.2324 29.2L86.2327 16.4777C86.2327 16.1709 86.1156 15.8759 85.9027 15.655C85.5089 15.2465 84.8513 14.5744 84.4327 14.1999Z"
          stroke="#AD2828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <g>
        <rect x="112.865" width="44" height="44" rx="8" fill="#FDF3F3" />
        <path
          d="M128.865 19.6V23.8M140.865 19.6V23.8M127.065 28H142.665C143.659 28 144.465 27.1941 144.465 26.2V17.8C144.465 16.8059 143.659 16 142.665 16H127.065C126.071 16 125.265 16.8059 125.265 17.8V26.2C125.265 27.1941 126.071 28 127.065 28ZM137.265 22C137.265 23.3255 136.191 24.4 134.865 24.4C133.54 24.4 132.465 23.3255 132.465 22C132.465 20.6745 133.54 19.6 134.865 19.6C136.191 19.6 137.265 20.6745 137.265 22Z"
          stroke="#AD2828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <g>
        <rect x="169.298" width="44" height="44" rx="8" fill="#FDF3F3" />
        <path
          d="M187.048 27.2202V27.1428M191.548 27.2202V27.1428M191.548 23.0286V22.9512M195.548 23.0286V22.9512M184.048 18.9143H198.048M185.857 13V14.543M196.048 13V14.5428M196.048 14.5428H186.048C184.391 14.5428 183.048 15.9244 183.048 17.6285V27.9143C183.048 29.6185 184.391 31 186.048 31H196.048C197.705 31 199.048 29.6185 199.048 27.9143L199.048 17.6285C199.048 15.9244 197.705 14.5428 196.048 14.5428Z"
          stroke="#AD2828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      {[
        "M22 44V78.8594H87.772",
        "M78.4326 44V78.8594",
        "M134.865 44V78.8594",
        "M191.298 44V78.8594H129.518",
      ].map((d, i) => (
        <path
          key={d}
          d={d}
          stroke="#AD2828"
          strokeWidth="2"
          strokeDasharray="2 2"
        />
      ))}

      <g>
        <path
          d="M108.664 58.8052C119.838 58.8052 128.896 67.6107 128.896 78.4731C128.896 89.3356 119.838 98.1411 108.664 98.1411C97.4905 98.1409 88.4326 89.3355 88.4326 78.4731C88.4326 67.6108 97.4905 58.8054 108.664 58.8052ZM108.664 75.3677L102.152 69.0376L98.958 72.1431L105.47 78.4731L98.958 84.8042L102.152 87.9097L108.664 81.5786L115.176 87.9097L118.371 84.8042L111.858 78.4731L118.37 72.1431L115.176 69.0376L108.664 75.3677Z"
          fill="#D92D17"
        />
      </g>
    </svg>
  );
}
